import { PageInfo } from '../../user/shared/models/pageInfoModel';
import { SortInfo } from '../../user/shared/models/sortInfoModel';

export class KioskGridParams {
    pageInfo : PageInfo = new PageInfo();
    sortInfo : SortInfo = new SortInfo();
    searchText : string = '';
}